import React, { useRef, useEffect } from "react";
// import video from "../assets/bgvideo.mp4";

const videoContainerStyle = {
  position: "fixed",
  top: "0",
  left: "0",
  width: "100%",
  height: "100%",
  zIndex: "-1", // Place it behind other content
};

const videoStyle = {
  objectFit: "cover",
  width: "100%",
  height: "100%",
};

const BackgroundVideo = ({ background }) => {
  return (
    <div style={videoContainerStyle}>
      {background.filetype === "basic" && (
        <div style={{ ...videoStyle, background: background.color }}></div>
      )}
      {background.filetype === "gradiant" && (
        <div
          style={{
            ...videoStyle,
            background: background.color,
            backgroundSize: "400% 400%",
            animation: "gradient 15s ease infinite",
          }}
        ></div>
      )}
      {background.filetype?.startsWith("image") && (
        <img src={background.url} style={videoStyle} />
      )}
      {background.filetype?.startsWith("video") && (
        <video muted autoPlay loop style={videoStyle} key={background.url}>
          <source
            src={background.url}
            // type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      )}
    </div>
  );
};

export default BackgroundVideo;
